import { Incident, IncidentNotification, IncidentType, NotificationParty } from "./types";

const SUGGESTED: { party: NotificationParty; role: string; when: (incident: Incident) => boolean }[] = [
  { party: "charge_nurse", role: "Nurse in charge", when: () => true },
  {
    party: "doc",
    role: "Director of care or administrator",
    when: (incident) =>
      incident.type === "unsafe_interaction" || incident.province === "ON" || incident.province === "QC"
  },
  { party: "physician", role: "Physician or nurse practitioner", when: () => true },
  { party: "sdm_family", role: "Family or substitute decision-maker", when: () => true },
  {
    party: "police",
    role: "Police",
    when: (incident) => incident.type === "unsafe_interaction" || incident.type === "wandering_zone"
  },
  {
    party: "ministry_CIS",
    role: "Director, Critical Incident System",
    when: (incident) => incident.province === "ON"
  },
  {
    party: "ministry_after_hours",
    role: "After-hours line 1-888-999-6973",
    when: (incident) => incident.province === "ON"
  },
  { party: "ah223", role: "AH-223-1 declaration (SISSS)", when: (incident) => incident.province === "QC" },
  { party: "CLPQS", role: "CLPQS", when: (incident) => incident.province === "QC" },
  {
    party: "disclosure",
    role: "Disclosure to the user or representative",
    when: (incident) => incident.province === "QC"
  }
];

export function suggestedNotifications(incident: Incident): IncidentNotification[] {
  return SUGGESTED.filter((row) => row.when(incident)).map((row, index) => ({
    id: `${incident.id}-notify-${index + 1}`,
    party: row.party,
    role: row.role,
    suggested: true,
    done: false
  }));
}

export function partyLabel(party: NotificationParty, locale?: string): string {
  const fr = locale === "fr";
  const labels: Record<NotificationParty, { en: string; fr: string }> = {
    charge_nurse: { en: "Nurse in charge", fr: "Infirmière responsable" },
    doc: { en: "Director of care", fr: "Directrice des soins" },
    physician: { en: "Physician or nurse practitioner", fr: "Médecin ou IPS" },
    sdm_family: { en: "Family or substitute decision-maker", fr: "Famille ou représentant" },
    police: { en: "Police", fr: "Police" },
    ministry_CIS: { en: "Director (Critical Incident System)", fr: "Directeur (système d'incidents critiques)" },
    ministry_after_hours: { en: "After-hours line", fr: "Ligne hors des heures" },
    CLPQS: { en: "CLPQS", fr: "CLPQS" },
    ah223: { en: "AH-223-1 declaration", fr: "Déclaration AH-223-1" },
    disclosure: { en: "Disclosure to the person or representative", fr: "Divulgation à l'usager ou au représentant" },
    inspector: { en: "Inspector", fr: "Inspecteur" },
    bc_mho: { en: "Medical health officer, through licensing", fr: "Médecin hygiéniste, via l'autorité" },
    bc_alr: { en: "Assisted Living Registry (HLTH 1622)", fr: "Assisted Living Registry (HLTH 1622)" },
    bc_funding: { en: "Funding program", fr: "Programme de financement" },
    bc_aga: { en: "Designated agency (optional)", fr: "Organisme désigné (facultatif)" },
    other: { en: "Other", fr: "Autre" }
  };
  return fr ? labels[party].fr : labels[party].en;
}

export function suggestedCategory(type: IncidentType): string {
  switch (type) {
    case "fall":
      return "Fall — confirm whether this is a critical incident";
    case "unsafe_interaction":
    case "responsive_behaviour":
      return "Responsive Behaviour / Abuse — you confirm the regulatory category";

    case "wandering_zone":
      return "Missing resident or exit-seeking";
    default:
      return "Other — confirm the category";
  }
}
